import { getMagicTextColor } from "cms/theme/helpers";
import Styled from "styled-components";

export type ValuePropositionHeaderVariant = "cursors" | "magic";

export const Container = Styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 0;
  gap: 1.5rem;
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 52rem;
  }
`;

export const AiTagContainer = Styled.div`
  background: linear-gradient(189.47deg, #CCB2FF 4.76%, #6419FF 92.85%);
  border-radius: 1.75rem;
  box-shadow: 0px 2px 8px 0px rgba(3, 3, 3, 0.16);
  padding: 1px;
`;

export const AiTagContent = Styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  padding: 0.5rem 1rem;
  border-radius: 1.75rem;
  background: linear-gradient(91deg, rgba(3, 3, 3, 0.30) 0%, rgba(85, 85, 85, 0.30) 100%), radial-gradient(59.46% 220% at 50% 100%, rgba(162, 117, 255, 0.10) 0%, rgba(100, 25, 255, 0.10) 100%), black;
`;

export const AiTagIcon = Styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

export interface HeadlineContainerProps {
  $variant?: ValuePropositionHeaderVariant;
}

export const HeadlineContainer = Styled.div<HeadlineContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.$variant === "magic" &&
    `
    background: linear-gradient(-45deg, #6419FF, #CBB2FF);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent !important;
  `}

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 38.625rem;
    margin-bottom: 0.5rem;
  }
`;

export interface DescriptionProps {
  $variant?: ValuePropositionHeaderVariant;
}

export const Description = Styled.div<DescriptionProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  p {
    font-weight: 560;
  }

  ${(props) =>
    props.$variant === "magic" &&
    `
    p {
      color: #FFF;
    }
  `}
`;

export const Link = Styled.a`
  text-decoration: none;
`;

export interface CursorIconProps {
  $position: {
    left?: string;
    right?: string;
    top?: string;
    bottom?: string;
  };
}

export const CursorIcon = Styled.img<CursorIconProps>`
  display: none;
  position: absolute;
  height: 2.375rem;
  left: ${(props) => props.$position.left};
  right: ${(props) => props.$position.right};
  top: ${(props) => props.$position.top};
  bottom: ${(props) => props.$position.bottom};

  ${(props) => props.theme.breakpoints.up("large")} {
    display: block;
  }
`;
